import Head from "next/head";
import axios from "axios";
import { parse } from "node-html-parser";

export default function Home({ headContents, bodyContents }: any) {
  // Parse headContents to extract specific elements
  let metaElements: any = [];
  let title = "Qrmenu.com";
  if (headContents) {
    const headRoot = parse(headContents);
    title = headRoot.querySelector("title")?.textContent || "Qrmenu.com";
    metaElements = headRoot.querySelectorAll("meta");
  }

  return (
    <>
      <Head>
        {title && <title>{title}</title>}
        {metaElements.map((meta: any, index: number) => {
          const attributesArray = Object.entries(meta.attributes).map(
            ([key, value]: [string, any]) => [key, value]
          );
          return <meta key={index} {...Object.fromEntries(attributesArray)} />;
        })}
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <div dangerouslySetInnerHTML={{ __html: bodyContents }} />
    </>
  );
}

export const getServerSideProps = async (context: any) => {
  let { paths } = context.query;

  const path = paths.length ? paths.join("/") : "";
  try {
    const res = await axios.get(
      `https://dopweb-repository.s3.us-west-2.amazonaws.com/qrmenu${
        path ? "/" + path : ""
      }/index.html`
    );
    let htmlContent = res.data;
    if (!htmlContent) {
      return { notFound: true };
    }

    // Replace instances with single quotes
    htmlContent = htmlContent.replace(
      /\/mydop-files\//g,
      `https://dopweb-repository.s3.us-west-2.amazonaws.com/qrmenu/mydop-files/`
    );

    htmlContent = htmlContent.replace(
      /"\/menus\//g,
      `"https://qr-menu-repo-prod.s3.us-west-2.amazonaws.com/`
    );
    const root = parse(htmlContent);

    // Extracting <head> contents
    const headContents = root?.querySelector("head")?.toString();
    // Extracting the rest of the body contents
    const bodyContents = htmlContent;

    return { props: { headContents: headContents || {}, bodyContents } };
  } catch (error) {
    // console.error("Error fetching external HTML content:", error);
    return { notFound: true };
  }
};
